/**
 * Thamel-style mega menu behavior
 * - Hover intent (small delay) so it doesn't flicker
 * - Stays open while cursor moves into dropdown
 * - Closes on outside click, ESC
 * - Sets dropdown top using fixed positioning (prevents "drop up")
 */
(() => {
  const root = document.querySelector('.thamel-header-root');
  if (!root) return;

  const nav = root.querySelector('.thamel-nav');
  const items = Array.from(root.querySelectorAll('.thamel-item.has-children'));
  if (!nav || !items.length) return;

  const OPEN_DELAY = 90;
  const CLOSE_DELAY = 140;

  let openItem = null;
  let openTimer = null;
  let closeTimer = null;

  const clearTimers = () => {
    if (openTimer) window.clearTimeout(openTimer);
    if (closeTimer) window.clearTimeout(closeTimer);
    openTimer = null;
    closeTimer = null;
  };

  const setBodyState = (isOpen) => {
    document.body.classList.toggle('thamel-mega-open', !!isOpen);
  };

  const setPanelTopVar = () => {
    const rect = nav.getBoundingClientRect();
    // dropdown should start right under the nav row
    document.documentElement.style.setProperty('--thamel-panel-top', `${Math.round(rect.bottom)}px`);
  };

  const closeAll = () => {
    clearTimers();
    items.forEach((it) => it.classList.remove('is-open'));
    openItem = null;
    setBodyState(false);
  };

  const open = (item) => {
    if (!item) return;

    // Update dropdown top every time we open (sticky headers, resize, etc.)
    setPanelTopVar();

    if (openItem && openItem !== item) openItem.classList.remove('is-open');

    item.classList.add('is-open');
    openItem = item;
    setBodyState(true);
  };

  const scheduleOpen = (item) => {
    clearTimers();
    openTimer = window.setTimeout(() => open(item), OPEN_DELAY);
  };

  const scheduleClose = () => {
    clearTimers();
    closeTimer = window.setTimeout(() => closeAll(), CLOSE_DELAY);
  };

  // Attach events
  items.forEach((item) => {
    const link = item.querySelector('.thamel-link');
    const panel = item.querySelector('.thamel-panel');

    item.addEventListener('mouseenter', () => scheduleOpen(item));
    item.addEventListener('mouseleave', () => scheduleClose());

    if (panel) {
      panel.addEventListener('mouseenter', () => {
        clearTimers();
        open(item);
      });
      panel.addEventListener('mouseleave', () => scheduleClose());
    }

    if (link) {
      link.addEventListener('focus', () => {
        clearTimers();
        open(item);
      });
    }
  });

  root.addEventListener('focusout', (e) => {
    const next = e.relatedTarget;
    if (!next || !root.contains(next)) scheduleClose();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeAll();
  });

  document.addEventListener('pointerdown', (e) => {
    if (!openItem) return;
    if (root.contains(e.target)) return;
    closeAll();
  });

  window.addEventListener('resize', () => {
    if (openItem) setPanelTopVar();
  }, { passive: true });

  window.addEventListener('scroll', () => {
    // keep it aligned while scrolling; if you prefer, change to closeAll()
    if (openItem) setPanelTopVar();
  }, { passive: true });

  // Initial set
  setPanelTopVar();
})();
// =========================================================
// Thamel Mobile Drawer
// =========================================================
(() => {
  const root = document.querySelector('.thamel-header-root');
  const drawer = document.getElementById('ThamelMobileDrawer');
  if (!root || !drawer) return;

  const openBtn = root.querySelector('.thamel-mobile-toggle');
  const closeEls = drawer.querySelectorAll('[data-thamel-close]');
  const panels = Array.from(drawer.querySelectorAll('.thamel-mobile-panel'));

  const activatePanel = (panelId) => {
    panels.forEach(p => p.classList.toggle('is-active', p.dataset.panel === panelId));
  };

  const openDrawer = () => {
    document.body.classList.add('thamel-mobile-open');
    drawer.setAttribute('aria-hidden', 'false');
    activatePanel('root');
     document.documentElement.style.overflow = 'hidden';
  };

  const closeDrawer = () => {
    document.body.classList.remove('thamel-mobile-open');
    drawer.setAttribute('aria-hidden', 'true');
    activatePanel('root');
     document.documentElement.style.overflow = '';  
  };

  openBtn?.addEventListener('click', openDrawer);
  closeEls.forEach(el => el.addEventListener('click', closeDrawer));

  // open submenu
  drawer.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-open-panel]');
    if (!btn) return;
    const target = btn.getAttribute('data-open-panel');
    if (target) activatePanel(target);
  });

  // back button
  drawer.addEventListener('click', (e) => {
    const back = e.target.closest('[data-back]');
    if (!back) return;

    // go back to previous panel based on what's active
    const active = drawer.querySelector('.thamel-mobile-panel.is-active');
    if (!active) return;

    const id = active.dataset.panel || 'root';
    if (id === 'root') return;

    // if panel id is like panel-a-b, go back to panel-a; else root
    const parts = id.split('-');
    if (parts.length >= 3) {
      // panel-<top>-<child> -> back to panel-<top>
      activatePanel(`panel-${parts[1]}`);
    } else {
      activatePanel('root');
    }
  });

  // ESC closes
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && document.body.classList.contains('thamel-mobile-open')) {
      closeDrawer();
    }
  });
})();
